// apps/client/src/ui/kit/Slot.tsx
import type { ReactNode } from 'react';
export function Slot(p: { label: string; selected?: boolean; qty?: number; onClick?: () => void; children?: ReactNode }) {
  return (
    <button type="button" aria-label={p.label} aria-pressed={!!p.selected} className={`slot${p.selected ? ' slot-selected' : ''}`} onClick={p.onClick}>
      {p.children}
      {p.qty !== undefined && p.qty > 1 && <span className="slot-qty">{p.qty}</span>}
    </button>
  );
}
